var _hr;
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import clsx from 'clsx';
import { Alert, Text } from 'reaxl';
import { useFeatures } from '@atc/features';
import EmailAdditionalInventory from '../EmailAdditionalInventory';
import EmailContext from '../EmailContext';
import EmailStaticContent from '../EmailStaticContent';
import EmailFormTitle from '../EmailFormTitle';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function EmailAlert(_ref) {
  let {
    isConfirmation,
    isOneClickOptedIn,
    isEditEmailModal,
    isUserProfileIncomplete,
    serverError,
    uiContext
  } = _ref;
  let componentClass = '';
  let customErrorMessage;
  let title;
  if (serverError === 'bapNotSelectedError') {
    componentClass = 'p';
    customErrorMessage = EmailStaticContent.bapNotSelectedError.errorMessage;
    title = EmailStaticContent.bapNotSelectedError.title;
  }
  if (isUserProfileIncomplete) {
    customErrorMessage = EmailStaticContent.userProfileIncompleteError.errorMessage;
    title = EmailStaticContent.userProfileIncompleteError.title;
  }
  if (customErrorMessage) {
    return /*#__PURE__*/_jsxs(Alert, {
      bsStyle: "danger",
      children: [/*#__PURE__*/_jsx(Text, {
        weight: "bold",
        componentClass: componentClass,
        children: title
      }), customErrorMessage]
    });
  }
  const oneClickStatus = isOneClickOptedIn ? EmailStaticContent.confirmation.oneClickEnabled : EmailStaticContent.confirmation.oneClickDisabled;
  const content = isEditEmailModal ? oneClickStatus : EmailStaticContent.confirmation.successMessage;
  return /*#__PURE__*/_jsx(Alert, {
    "data-cmp": isConfirmation ? 'emailConfirmation' : '',
    bsStyle: serverError ? 'warning' : 'success',
    className: clsx({
      'margin-top-2': isConfirmation || uiContext !== 'default'
    }),
    children: serverError || /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    })
  });
}

/**
 *  EmailFormHeader renders all content above the email form
 *
 */
const EmailFormHeader = /*#__PURE__*/React.memo(_ref2 => {
  let {
    additionalInventoryInfo = {},
    handleListingSelect,
    isConfirmation = false,
    isEditEmailModal = false,
    isUserProfileIncomplete = false,
    nextSteps,
    isIncentivesSheet,
    isOneClickOptedIn = false,
    serverError,
    showAlert
  } = _ref2;
  const {
    email_confirmation_next_steps: [isNextStepsEnabled]
  } = useFeatures(['email_confirmation_next_steps']);
  const additionalInventory = additionalInventoryInfo?.listings;
  const {
    uiContext
  } = useContext(EmailContext);
  const showNextSteps = isNextStepsEnabled && (showAlert || !!additionalInventory?.length) && isConfirmation && !serverError;
  const showOneClickEmailFailure = isUserProfileIncomplete && isEditEmailModal;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [['basic', 'calculatorOfferSummary', 'default', 'split'].includes(uiContext) && !isConfirmation && /*#__PURE__*/_jsx(EmailFormTitle, {
      isConfirmation: isConfirmation,
      isSmallTitle: isIncentivesSheet
    }), (showAlert || showOneClickEmailFailure) && /*#__PURE__*/_jsx(EmailAlert, {
      serverError: serverError,
      isConfirmation: isConfirmation,
      isEditEmailModal: isEditEmailModal,
      isUserProfileIncomplete: isUserProfileIncomplete,
      isOneClickOptedIn: isOneClickOptedIn,
      uiContext: uiContext
    }), showNextSteps && nextSteps, !!additionalInventory?.length && showNextSteps && (_hr || (_hr = /*#__PURE__*/_jsx("hr", {
      className: "margin-vertical-3"
    }))), !!additionalInventory?.length && /*#__PURE__*/_jsx(EmailAdditionalInventory, {
      additionalInventoryInfo: additionalInventoryInfo,
      handleListingSelect: handleListingSelect
    })]
  });
});
export default EmailFormHeader;